import React, { useEffect, useState, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonContent, useIonViewDidLeave } from '@ionic/react'
import { decorationMobx, storeMobx, advertMobx } from '@mobxStore'
import { setCSSProperty, checkInVisible } from '@utils'
import { classNames, useThrottle } from '@dt/fe-utils'
import { MyCardModule, PointCardModule, LotteryModule, UnacquiredCoupon, Advert } from '@cps'
import Entrance from './Entrance'
import Custom from './Custom'
import defaultLogo from 'assets/images/default-logo.png'
import { LanguageSwitch } from '../'
import Notice from '../Notice'
import './index.scss'

interface IProps {
}

/** 首页默认模板 */
const HomeDefault: React.FC = (IProps: any) => {
  const { homeDecorates } = decorationMobx
  const availableAdsMap = advertMobx.availableAdsMap as any
  const scale = window.innerWidth / 375
  const hasBrand = availableAdsMap?.home?.length
  // component marginTop
  const topDistance = Config.codeType === 'brand'
    ? homeDecorates?.entrySetting?.brandCode?.topDistance
    : homeDecorates?.entrySetting?.storeCode?.topDistance
  // 快捷入口top
  const componentStyle = useMemo(() => {
    return {
      marginTop: `${(450 - (topDistance || 0)) * scale}px`,
    }
  }, [topDistance])
  // 首页广告高度
  const minHieghtStyle = useMemo(() => {
    return {
      // minHeight: `${450 * scale}px`
    }
  }, [])

  // 滚动播放
  const handleScroll = useThrottle(function () {
    const videoContainer = document.querySelector('#homeCustomVideo_promotionVideo') as HTMLVideoElement
    if (!videoContainer) return
    const inVisible = checkInVisible(videoContainer)
    if (inVisible) {
      try {
        videoContainer?.paused && videoContainer?.play()
      } catch (error) { }
    } else {
      try {
        !videoContainer?.paused && videoContainer?.pause()
      } catch (error) { }
    }
  }, 100)

  // 页面离开暂停播放
  useIonViewDidLeave(() => {
    const videoContainer = document.querySelector('#homeCustomVideo_promotionVideo') as any
    if (!videoContainer) return
    try {
      videoContainer?.pause()
    } catch (error) { }
  })

  // useEffect homeDecorates
  useEffect(() => {
    const cssMap = {
      '--dr-theme-bg-color': homeDecorates.backgroundColor,
    }
    setCSSProperty('.default-page-content', cssMap)
  }, [homeDecorates])

  return (
    <IonContent
      className='home-page-content default-page-content'
      scrollEvents
      onIonScroll={handleScroll}
    >
      <LanguageSwitch />
      <div
        className={classNames('home-banner-wrapper', { default: !hasBrand && !homeDecorates.backgroundImage?.url, brand: hasBrand })}
        style={minHieghtStyle}
      >
        {
          hasBrand ? (
            <Advert type='home' />
          ) : (
            <>
              {
                !homeDecorates.backgroundImage?.url ? (
                  <div className='logo-container'>
                    <img src={storeMobx.brand.logo || defaultLogo} />
                    <h3>{storeMobx.brand.brandName}</h3>
                  </div>
                ) : <img className='back-container' src={homeDecorates.backgroundImage?.url} style={minHieghtStyle} />
              }
              <Notice type='home' isOnly />
            </>
          )
        }
      </div>
      <div className='home-components-wrapper' style={componentStyle}>
        {homeDecorates.entrySetting && (
          <Entrance data={Config.codeType === 'brand' ? homeDecorates.entrySetting.brandCode : homeDecorates.entrySetting.storeCode} />
        )}
        {
          homeDecorates.sortContent?.map(sort => {
            let sortContent = null as any
            sort === 'memberEntries' && (sortContent = homeDecorates.memberEntries?.map(item => {
              let component = null as any
              item === 'memberCard' && (component = <MyCardModule source='home' />)
              item === 'receiveCoupon' && (component = <UnacquiredCoupon />)
              item === 'memberPointsCard' && (component = <PointCardModule />)
              item === 'luckyDraw' && (component = <LotteryModule />)
              return component
                ? <div key={item} className={`component-container${['memberCard', 'memberPointsCard'].includes(item) ? ' no-margin' : ''}`}>{component}</div>
                : null
            }))
            sort === 'groupMeal' && homeDecorates.groupMeal?.enable &&
              (sortContent = <Custom key={sort} type={sort} data={homeDecorates.groupMeal} />)
            sort === 'brandStory' && homeDecorates.brandStory?.enable &&
              (sortContent = <Custom key={sort} type={sort} data={homeDecorates.brandStory} />)
            sort === 'promotionVideo' && homeDecorates.promotionVideo?.enable &&
              (sortContent = <Custom key={sort} type={sort} data={homeDecorates.promotionVideo} />)
            return sortContent
          })
        }
      </div>
    </IonContent>
  )
}

export default observer(HomeDefault)
